import Form from 'react-bootstrap/Form'
import classnames from 'classnames'

import { type FileBrowserItem } from './types'
import styles from './FileBrowser.module.scss'

interface FileBrowserRowTrailingProps {
  item: FileBrowserItem
  isSelected: boolean
  showCheckboxes: boolean
  isFolderSelectable: boolean
  isFileSelectable: boolean
  checkType: 'radio' | 'checkbox'
  onSelect: (itemId: string) => void
  onOpenFolder: (folderId: string, folderName: string) => void
}

export const FileBrowserRowTrailing = ({
  item,
  isSelected,
  showCheckboxes,
  isFolderSelectable,
  isFileSelectable,
  checkType,
  onSelect,
  onOpenFolder,
}: FileBrowserRowTrailingProps) => {
  const isFolder = item.type === 'folder'

  if (!showCheckboxes) {
    return <span className={styles.colChevron}>{isFolder ? <i className='bi bi-chevron-right zocks-text-gray-400' /> : null}</span>
  }
  if (isFolder && !isFolderSelectable) {
    return (
      <span className={styles.colCheckbox}>
        <i className='bi bi-chevron-right zocks-text-gray-400' />
      </span>
    )
  }
  if (isFolder && isFolderSelectable) {
    return (
      <span className={classnames(styles.colCheckbox, 'd-flex align-items-center gap-1')}>
        <Form.Check
          type={checkType}
          checked={isSelected}
          onChange={() => onSelect(item.id)}
          onClick={(e) => e.stopPropagation()}
          aria-label={`Select ${item.name}`}
          className='flex-shrink-0 m-0'
        />
        <button
          className={styles.openFolderButton}
          onClick={(e) => {
            e.stopPropagation()
            onOpenFolder(item.id, item.name)
          }}
          aria-label={`Open ${item.name}`}
        >
          <i className='bi bi-chevron-right' />
        </button>
      </span>
    )
  }
  if (isFileSelectable) {
    return (
      <span className={styles.colCheckbox}>
        <Form.Check
          type={checkType}
          checked={isSelected}
          onChange={() => onSelect(item.id)}
          onClick={(e) => e.stopPropagation()}
          aria-label={`Select ${item.name}`}
          className='flex-shrink-0 m-0'
        />
      </span>
    )
  }
  return <span className={styles.colCheckbox} />
}
